import PropTypes from 'prop-types';
import React from 'react';

import {ProteinAlignment} from 'constants/AlignmentConstants';
import {
  getAminoAcidMatrix,
  getIdenticalSites,
  getLength,
  getNumMatchingPairs,
  getNumNonGapPairs,
  getNumProteins,
  getPairwisePercentIdentity,
} from 'molbio/aa-sequences/alignments/AaSequenceAlignmentStatsUtil';
import {getNonConsensusRows} from 'molbio/aa-sequences/alignments/AaSequenceAlignmentUtil';

const ProteinAlignmentStats = (props: {
  alignment: ProteinAlignment;
  selectionStart: number;
  selectionEnd: number | null;
}): JSX.Element => {
  const aminoAcidMatrix = getAminoAcidMatrix(
    getNonConsensusRows(props.alignment),
    props.selectionStart,
    props.selectionEnd
  );
  const pairwiseIdentity = Math.round(
    getPairwisePercentIdentity(getNumMatchingPairs(aminoAcidMatrix), getNumNonGapPairs(aminoAcidMatrix))
  );
  return (
    <div className="proteinAlignmentStats">
      <div className="proteinAlignmentStats-text-container">
        <div>
          <strong>Alignment Statistics</strong>
        </div>
        <div>
          Length: {getLength(aminoAcidMatrix)}
          <br />
          Number of AA Sequences: {getNumProteins(aminoAcidMatrix)}
          <br />
          Identical Sites: {getIdenticalSites(aminoAcidMatrix)}
          <br />
          Pairwise Identity: {`${pairwiseIdentity}%`}
        </div>
      </div>
    </div>
  );
};

ProteinAlignmentStats.propTypes = {
  alignment: PropTypes.object.isRequired,
  selectionStart: PropTypes.number.isRequired,
  selectionEnd: PropTypes.number,
};

export default ProteinAlignmentStats;
